import { render, staticRenderFns } from "./real.vue?vue&type=template&id=e37fb86c&scoped=true"
import script from "./real.vue?vue&type=script&lang=js"
export * from "./real.vue?vue&type=script&lang=js"
import style0 from "./real.vue?vue&type=style&index=0&id=e37fb86c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37fb86c",
  null
  
)

export default component.exports